export const isActiveCampaign = (startDate, endDate) => {
  return new Date() < new Date(endDate) && new Date() >= new Date(startDate)
}
